import {
  CONFIRM_ORDER_ADDR,
  CONFIRM_ORDER_CARTLIST,
  CONFIRM_ORDER_CYCOUNT,
  CONFIRM_ORDER_TOTAL,
  SEARCH_GOODS_LIST,
  SET_IS_SHOW_QRCODE
} from './mutation-types'

export default {
  // 生成订单的地址
  [CONFIRM_ORDER_ADDR] (state, confirmOrderAddr) {
    state.confirmOrderAddr = confirmOrderAddr
  },
  // 生成订单的商品列表
  [CONFIRM_ORDER_CARTLIST] (state, confirmOrderCartlist) {
    state.confirmOrderCartlist = confirmOrderCartlist
  },
  // 生成订单总费用
  [CONFIRM_ORDER_CYCOUNT] (state, confirmOrderCycount) {
    state.confirmOrderCycount = confirmOrderCycount
  },
  // 生成订单的总价钱
  [CONFIRM_ORDER_TOTAL] (state, confirmOrderTotal) {
    state.confirmOrderTotal = confirmOrderTotal
  },
  // 生成订单的总价钱
  [SEARCH_GOODS_LIST] (state, searchGoodsList) {
    state.searchGoodsList = searchGoodsList
  },
  // 是否显示二维码弹框
  [SET_IS_SHOW_QRCODE] (state, isShowQrCode) {
    state.isShowQrCode = isShowQrCode
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js